<template>
  <div>
    <div class="d-flex justify-center align-center" fill-height style="background-color:#EFEFEF; height: 100vh; margin:0px;">

      <div class="flex-column">
<v-alert elevation="10" v-if="errormessage!=''" class="rounded-xl"
  type="error"
>{{errormessage}}</v-alert>

    <div class="d-flex justify-center align-center elevation-20 rounded-xl" style="overflow:hidden; height:600px;background-color:white;">
      
      <div class="pa-6 d-flex justify-center align-stretch" style="width:520px; background-color:white; height:100%;">


        
        <div style="width:100%;" class="d-flex; justify-center;">
         



<div class="d-flex flex-grow-1  flex-column justify-center" style="margin:auto;height:100%; width:70%;">
  <div>
    

  


     
      <h1 v-if="formState=='register'">Register</h1>
      <h1 v-if="formState=='login'">Sign In</h1>

      <div v-if="formState=='register'" class="mb-5">Let's get started.</div>
      <div v-if="formState=='login'" class="mb-5">Venue checkins made easy.</div>

  

     <v-text-field v-if="false" v-model="form.businessName" outlined label="Business Name">Business Name</v-text-field>
        <v-text-field v-if="false" v-model="form.businessPostcode" outlined label="Business Postcode">PostCode</v-text-field>
        <v-text-field v-if="formState=='register'" v-model="form.yourName" outlined label="Your Name">Name</v-text-field>
        <v-text-field v-if="formState=='register'" v-model="form.yourMobile" outlined label="Mobile">Mobile</v-text-field>
        <v-text-field v-model="form.yourEmail" outlined label="Email">Email</v-text-field>
         <v-text-field
            outlined
            v-model="form.password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Password"
            hint="At least 8 characters"
            counter
            @click:append="show1 = !show1"
          ></v-text-field>
     <div style="text-align:right;">
    <v-btn text  v-if="formState=='login'" @click="formState='register'">Don't have an account?</v-btn><v-btn v-if="formState=='register'" text @click="formState='login'">Already Registered?</v-btn>
           <v-btn @click="register"  v-if="formState=='register'" rounded style="color:#FFF; background: linear-gradient(317deg, rgba(34,193,195,0.4) 0%, rgba(253,187,45,0.4) 100%);" elevation="3">Register</v-btn>
    <v-btn @click="login" v-if="formState=='login'" depressed rounded style="color:#FFF; background: linear-gradient(317deg, rgba(34,193,195,0.4) 0%, rgba(253,187,45,0.4) 100%);" elevation="3">Login</v-btn>

    </div>
    
    </div>
    </div>
    
    </div>
    
      </div>

      <div class="justify-end align-end flex-column d-none d-lg-flex" style="width:620px;background: linear-gradient(317deg, rgba(34,150,150,0.4) 0%, rgba(253,187,45,0.4) 100%);height:100%;">
              <h1 style="width:100%; color:#FFF; text-shadow:0px 0px 15px rgba(0,0,0,0.35); text-align:center;" class="pa-10">easysign.in</h1>
<img width="70%" height="70%" src="/loginImage.png" />



      </div>
      </div>
        
      </div>
      </div>

    <div v-show="false">
    <v-row class="text-left">
      <v-col cols="4">


        
        <v-card rounded elevation="2">
          <v-card-title>Register</v-card-title>
          <v-card-text>

      

      <v-sheet>

       
</v-sheet>
  <v-card-actions>
    
   
  </v-card-actions>
          </v-card-text></v-card>

      </v-col>
    </v-row></div>
  </div>
</template>

<script>

import axios from 'axios';
import * as firebase from 'firebase/app';

// eslint-disable-next-line
import * as firebaseAuth from 'firebase/auth';


import { mapMutations } from 'vuex';
import {mapGetters} from 'vuex';

  export default {
    name: 'HelloWorld',

    data () {
      return {
        errormessage:"",
        form:{
          yourEmail:"",
          password:"",
          yourName: "",
          yourMobile: "",
          businessName:"",
          businessPostcode:"",
        },
        formState: "login",
        show1: false,
        password: '',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => (`The email and password you entered don't match`),
        },
      }
    },
    computed:{
      ...mapGetters(["getAxiosConfig","returnAccount"]),
    },
    methods:
    {
      ...mapMutations([
        "setIdToken",
        "setAccount"
      ]),
      login: function(){
        var t=this;
        firebase.auth().signInWithEmailAndPassword(this.form.yourEmail, this.form.password).then(data =>{
          data.user.getIdToken().then(token=>{
                
                
                  t.setIdToken(token);


                  axios.get(
                  t.GLOBAL_CONFIG.apiURL + "Account",
                  t.getAxiosConfig
                  ).then(data=>{
                      
                      t.setAccount(data.data);

                      if(data.data.hasRegisteredUser && data.data.hasPrimaryBusiness){
                        t.$router.push("/admin/splash")
                      }else{
                        t.$router.push("/setup")
                      }
                  }).catch(exception=>{t.errormessage="Error getting account details";});

         
         })
        }).catch(exception=>{t.errormessage="Error loging in.";});
      },
      register: function(){
        var t = this;
        firebase
        .auth()
        .createUserWithEmailAndPassword(this.form.yourEmail, this.form.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.form.yourName
            })
            .then(() => {

   
              
                firebase.auth().currentUser.getIdToken().then(function(idToken) {  
                  t.setIdToken(idToken);


           
                  axios.post(
                  t.GLOBAL_CONFIG.apiURL + "Account",
                  {
                    "businessName": t.form.businessName,
                    "businessPostcode": t.form.businessPostcode,
                    "yourName": t.form.yourName,
                    "yourMobile": t.form.yourMobile,
                    "yourEmail": t.form.yourEmail
                  },
                  t.getAxiosConfig
                  ).then(data=>{t.$router.push("/admin/splash")});


                });
            });

        })
        .catch(err => {
          this.error = err.message;
        });

      
     
     
     }
    }


  }
</script>
